var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalonSocial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Salon_Social_White",
    "data-name": "Salon Social_White",
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.729,
    height: 82.733,
    viewBox: "0 0 82.729 82.733",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f5f5f5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    className: "cls-1",
    d: "M82.74,15.755a3.639,3.639,0,0,0-3.635-3.637H63.187V7.063A3.637,3.637,0,0,0,61.974,0H20.77a3.637,3.637,0,0,0-1.21,7.065v5.054H3.64a3.637,3.637,0,0,0-1.213,7.063V74.252A1.213,1.213,0,0,0,3.64,75.461H26.828l-6.786,5.09a1.213,1.213,0,0,0,.726,2.182h41.2a1.213,1.213,0,0,0,.729-2.182l-6.785-5.09H79.106a1.213,1.213,0,0,0,1.209-1.209h0V19.181a3.637,3.637,0,0,0,2.426-3.426ZM63.19,19.389h14.7v41.2H63.187ZM20.77,2.423h41.2a1.213,1.213,0,1,1,0,2.423H25.617a1.213,1.213,0,0,0,0,2.423H60.769V73.036H58.34V47.265a1.213,1.213,0,0,0-1.213-1.217H25.617a1.213,1.213,0,0,0-1.21,1.213V73.049H21.981V6.054a1.213,1.213,0,0,0-1.213-1.213h0a1.213,1.213,0,0,1,0-2.423ZM42.585,73.049V58.17h8.481V73.037Zm-10.908,0V58.17h8.484V73.037Zm20.6-17.29H30.466a1.213,1.213,0,0,0-1.213,1.213h0V73.049H26.83V48.475H55.917V73.037H53.492V56.96a1.213,1.213,0,0,0-1.213-1.213ZM19.558,19.389v41.2H4.853v-41.2ZM3.64,14.542H19.558v2.423H3.64a1.213,1.213,0,1,1,0-2.423ZM4.853,63.017h14.7v10.02H4.853ZM58.337,80.308H24.406l6.464-4.847H51.876Zm4.847-7.271V63.017h14.7v10.02ZM79.106,16.965H63.185V14.542H79.106a1.213,1.213,0,0,1,0,2.423Z",
    transform: "translate(-0.011)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    className: "cls-1",
    d: "M33.638,114.264h7.437a1.213,1.213,0,0,0,1.213-1.213V98.5a1.213,1.213,0,0,0-1.213-1.213H33.638a1.213,1.213,0,0,0-1.21,1.213h0v14.542a1.213,1.213,0,0,0,1.21,1.219Zm1.213-14.542H39.86V111.84H34.853Z",
    transform: "translate(-25.162 -75.477)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    className: "cls-1",
    d: "M301.246,97.29H293.81A1.213,1.213,0,0,0,292.6,98.5h0v14.542a1.213,1.213,0,0,0,1.21,1.219h7.435a1.213,1.213,0,0,0,1.21-1.213V98.5a1.213,1.213,0,0,0-1.21-1.213Zm-1.213,14.545h-5.009V99.727h5.009Z",
    transform: "translate(-227 -75.477)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    className: "cls-1",
    d: "M33.638,200.745h7.437a1.213,1.213,0,0,0,1.213-1.21V184.99a1.213,1.213,0,0,0-1.213-1.21H33.638a1.21,1.21,0,0,0-1.21,1.21v14.545A1.21,1.21,0,0,0,33.638,200.745ZM34.851,186.2H39.86v12.107H34.853Z",
    transform: "translate(-25.162 -142.575)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    className: "cls-1",
    d: "M301.246,183.78H293.81a1.21,1.21,0,0,0-1.21,1.21v14.545a1.21,1.21,0,0,0,1.21,1.21h7.435a1.21,1.21,0,0,0,1.21-1.21V184.99A1.21,1.21,0,0,0,301.246,183.78Zm-1.213,14.542h-5.009V186.215h5.009Z",
    transform: "translate(-227 -142.575)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    className: "cls-1",
    d: "M129.805,74.48H122.37a1.213,1.213,0,0,0-1.21,1.213h0V90.235a1.213,1.213,0,0,0,1.21,1.213h7.435a1.213,1.213,0,0,0,1.21-1.213V75.693A1.213,1.213,0,0,0,129.805,74.48Zm-1.212,14.545h-5V76.917H128.6Z",
    transform: "translate(-93.998 -57.781)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    className: "cls-1",
    d: "M214.116,75.93h-7.424a1.213,1.213,0,0,0-1.213,1.209h0V91.683a1.213,1.213,0,0,0,1.213,1.213h7.424a1.213,1.213,0,0,0,1.21-1.213V77.139A1.21,1.21,0,0,0,214.116,75.93ZM212.9,90.472h-5V78.365h5.009Z",
    transform: "translate(-159.413 -58.906)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalonSocial);
export default __webpack_public_path__ + "static/media/Salon Social.b0541f5666710cc7c3ceb0de7b722ffd.svg";
export { ForwardRef as ReactComponent };